<template>
  <div class="md-layout md-gutter">
    <div class="md-layout-item md-size-65">
      <sensor-autocomplete
        id="sensores"
        v-model="sensorId"
        name="sensores"
        :local-id="localId"
        :required="true"
      />
    </div>
    <div class="md-layout-item md-size-35">
      <md-field>
        <label>Quantidade de valores</label>
        <md-input
          v-model="quantidadeDadosAnteriores"
          required
          type="number"
          @input="change"
        />
      </md-field>
    </div>
  </div>
</template>

<script>
import SensorAutocomplete from '../../autocomplete/SensorAutocomplete.vue'

export default {
  name: 'TermoAvg',
  components: { SensorAutocomplete },
  props: {
    localId: {
      type: String,
      required: true,
    },
    initialSensorId: {
      type: String,
      default: null,
    },
    initialValue: {
      type: Number,
      default: null,
    },
  },
  data: () => ({
    sensorId: null,
    quantidadeDadosAnteriores: 0,
  }),
  watch: {
    sensorId() {
      this.change()
    },
  },
  beforeMount() {
    if (this.initialSensorId) {
      this.sensorId = this.initialSensorId
    }
    if (this.initialValue) {
      this.quantidadeDadosAnteriores = this.initialValue
    }
  },
  methods: {
    change() {
      this.$emit('change', {
        sensorId: this.sensorId,
        quantidadeDadosAnteriores: this.quantidadeDadosAnteriores,
      })
    },
  },
}
</script>

<style scoped></style>
